import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AUTH_DIALOG_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, AUTH_DIALOG_TRANSLATION_KEY, {
  AUTH_DIALOG_MOBILE_HEADER_TITLE: 'Únete hoy',
  AUTH_DIALOG_MOBILE_HEADER_SUBTITLE: 'Vive la mejor experiencia de aprendizaje creativa y digital.',
  AUTH_DIALOG_MOBILE_HEADER_TITLE_PROMO: 'Você está a um passo de começar!',
  AUTH_DIALOG_MOBILE_HEADER_SUBTITLE_PROMO: 'Matricule-se e acesse os cursos gratuitos da Crehana.',
  // Aside
  YOU_ARE_ABOUT_TO_START: 'Você está a um passo de começar',
  GET: 'Tenha acesso',
  FREE: ' gratuito ',
  COURSES_AND_RESOURCES: 'a cursos, vidas, recursos para download e muito mais.',
  // Switcher
  REGISTER_TITLE: 'Junte-se à comunidade',
  REGISTER_SUBTITLE: 'Seja parte da nova geração de profissionais digitais.',
  LOGIN_TITLE: 'Bem-vindo novamente.',
  LOGIN_MODAL_SUBTITLE: 'Faça o login para continuar aprendendo',
  LOGIN_REGISTER_CONTINUE: 'ou continue com',
  LOGIN_REGISTER_CONTINUE_2: 'Ou crie uma conta com',
  REGISTER: 'Inscreva-se',
  LOGIN_NOT_MEMBER: 'Ainda não é membro?',
  REGISTER_NOT_MEMBER: 'Já tem uma conta?',
  LOGIN_REGISTER: 'Cadastre-se',
  REGISTER_LOGIN: 'Entrar',
  // SignIn
  AUTH_VALIDATION_USER_LENGTH: 'El campo usuario debe tener entre 6 y 75 caracteres',
  AUTH_VALIDATION_PASSWORD_LENGTH: 'Sua senha deve ter entre 6 e 20 caracteres',
  LOGIN_EMAIL: 'Usuário ou e-mail',
  AUTH_VALIDATION_REQUIRED: 'Campo obrigatório',
  LOGIN_PASSWORD: 'Senha',
  LOGIN_FORGET_PASSWORD: 'Esqueceu sua senha?',
  LOGIN_MAIN_BUTTON: 'Inicie sessão',
  // SignUp
  REGISTER_EMAIL: 'Correio eletrônico',
  AUTH_VALIDATION_EMAIL_IN_USE: 'O e-mail inserido já está em uso',
  AUTH_VALIDATION_VALID_EMAIL: 'Digite um endereço de email válido',
  AUTH_VALIDATION_LEGALS_REQUIRED: 'Você deve aceitar os Termos, Condições e Políticas para se registrar.',
  REGISTER_FIRST_NAME: 'Nome',
  REGISTER_LASTNAME: 'Sobrenome',
  // Affiliate aside
  AFFILIATE_REGISTER_TITLE_PART_A: 'Cadastre-se e Ganhe\n',
  AFFILIATE_REGISTER_TITLE_PART_B: 'até 20% do valor da compra.',
  AFFILIATE_LOGIN_TITLE: 'Junte-se hoje',
  AFFILIATE_LOGIN_SUBTITLE: 'Faça parte da nova geração de profissionais digitais.'
});